import React from 'react';
import { StyledCustomEvent } from '../../common/styles/devices/Calendar';

const format24Hours = (dateObj: Date) => {
  return `${dateObj.getHours().toString().padStart(2, '0')}:${dateObj.getMinutes().toString().padStart(2, '0')}`;
}

export const CustomEvent = (props) => {  
  return (    
      <StyledCustomEvent>
        {`${format24Hours(props.event.dtstart)}`}   
      </StyledCustomEvent>   
  )
}

export const CustomEventWrapper = (props) => {  
    
  let style: any = {
    top: `${props.style.top}%`,
    left: `${props.style.left}%`,
    width: `${props.style.width}%`,
    height: `${props.style.height}%`,
    background: props.event.style.background
  } 
    
  if (props.event.focus) {
    if (props.event.saved) {
      style.border = `3px solid  ${props.event.style.border}`;
    } else {
      style.border = `3px dashed  ${props.event.style.border}`;
    }
  } else {
    if (props.event.saved) {
      style.border = `1px solid  ${props.event.style.border}`;
    } else {
      style.border = `2px dashed  ${props.event.style.border}`;
    }
  }
      
  return (
    <div onClick={e => props.onClick(props.event, e)} className="rbc-event" style={style}>{props.components.event(props)}</div>
  )
}

